import tw from "tailwind-styled-components";

// Home Categories Skeleton Loading Component
export const HomeCategoriesLoading = () => (
  <Container>
    <Wrapper>
      <Grid>
        {[...Array(3)].map((_, sectionIndex) => (
          <Section key={sectionIndex}>
            <Title />     
            <ItemsGrid>         {/*  Grid - 2x2 */}
              {[...Array(4)].map((_, itemIndex) => (
                <Item key={itemIndex}>
                  <Image />
                  <Name />
                </Item>
              ))}
            </ItemsGrid>
            <Button />
          </Section>
        ))}
      </Grid>
    </Wrapper>
  </Container>
);

// Styled Components
const Container = tw.div`bg-gray-50 py-8`;
const Wrapper = tw.div`mx-auto px-4`;
const Grid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6`;
const Section = tw.div`bg-white rounded-lg p-4 animate-pulse`;
const Title = tw.div`bg-gray-200 h-6 rounded mb-4 w-1/2`;
const ItemsGrid = tw.div`grid grid-cols-2 gap-3 mb-4`;
const Item = tw.div`text-center`;
const Image = tw.div`aspect-square bg-gray-200 rounded mb-2`;
const Name = tw.div`bg-gray-200 h-4 rounded w-24 mx-auto`;
const Button = tw.div`bg-gray-200 h-5 rounded w-28`;
